import React, { Component } from 'react';
import LabeledInput from '../../shared/components/labeled-input';
import LabeledTextarea from '../../shared/components/labeled-textarea';
import PropTypes from 'prop-types';
import { getFieldValue } from '../../shared/services/common-functions';


class PrimePartInfo extends Component {

    state = {
        correctPartNumber: '',
        primePartDescription: '',
    }

    originalPartNumber = '';

    partArea = '';

    totalCost = '';

    partAmount = '';

    laborHours = '';

    laborAmountUsd = '';

    otherCreditsNetAmount = '';

    dealerParticipationAmount = '';

    companyParticipationAmount = '';

    customerParticipationAmount = '';

    factoryAmount = '';

    nonMetric = '';

    failureMode = '';

    downtime = '';

    componentNonMetric = '';

    multipleSuppliers = '';

    multipleFail = '';

    isCmpInpEdited = false;
    componentCodeEditable = false;

    failedTrackSerialNumber = '';


    componentWillMount = () => {

        this.assignValue( this.props.claimPartDetails );

    }

    componentWillReceiveProps ( nextProps ) {
        //Helpdesk inc5693774
        // const claimCorrectedPartNumber = nextProps.claimPartDetails.partNumber.corrected,
        //     primePartDescription = nextProps.claimPartDetails.partDescription.corrected;

        // if ( claimCorrectedPartNumber !==
        //     this.props.claimPartDetails.partNumber.corrected ||
        //     primePartDescription !==
        //     this.props.claimPartDetails.partDescription.corrected ) {

            this.assignValue( nextProps.claimPartDetails );

        //}
        //Helpdesk inc5693774

    }


    assignValue = claimPartDetails => {

        if ( claimPartDetails !== undefined ) {

            if ( claimPartDetails.partNumber !== undefined ) {

                this.originalPartNumber = getFieldValue( claimPartDetails.partNumber.original );

                const { corrected } = claimPartDetails.partNumber;
                const { partDescription } = claimPartDetails;
                this.setState( {
                    correctPartNumber: getFieldValue( corrected ),
                    primePartDescription: getFieldValue( partDescription.corrected ),
                } );

            }

            if ( claimPartDetails.amounts !== undefined ) {

                const {
                    otherCreditsNetAmountUsd,
                    dealerParticipationAmountUsd,
                    companyParticipationAmountUsd,
                    customerParticipationAmountUsd,
                } = claimPartDetails.amounts;

                this.totalCost = getFieldValue( claimPartDetails.amounts.claimAmountUsd );
                this.partAmount = getFieldValue( claimPartDetails.amounts.partAmountUsd );
                this.laborHours = getFieldValue( claimPartDetails.amounts.laborHours );
                this.laborAmountUsd = getFieldValue( claimPartDetails.amounts.laborAmountUsd );
                this.otherCreditsNetAmount = getFieldValue( otherCreditsNetAmountUsd );
                this.dealerParticipationAmount = getFieldValue( dealerParticipationAmountUsd );
                this.companyParticipationAmount = getFieldValue( companyParticipationAmountUsd );
                this.customerParticipationAmount = getFieldValue( customerParticipationAmountUsd );
                this.factoryAmount = getFieldValue( claimPartDetails.amounts.factoryAmountUsd );

            }

            if ( claimPartDetails.component !== undefined ) {

                const { componentNonMetric } = claimPartDetails.component;

                this.componentCodeEditable = claimPartDetails.component.componentCodeEditable;
                this.componentNonMetric = getFieldValue( componentNonMetric );

            }


            this.partArea = getFieldValue( claimPartDetails.machineArea );
            this.nonMetric = getFieldValue( claimPartDetails.nonMetric );
            this.failureMode = getFieldValue( `${claimPartDetails.failureMode} ${' - '}
            ${claimPartDetails.failureModeDescription}` );
            this.downtime = getFieldValue( claimPartDetails.downtime );
            this.multipleFail = getFieldValue( claimPartDetails.multipleFail );
            this.failedTrackSerialNumber = getFieldValue( claimPartDetails.failedTrackSerialNumber);

        }

    }

    onEditBtnClicked = () => {

        this.props.enableEditCmp( 'Prime Part Failure' );

    }

    onSaveBtnClicked = () => {

        if ( this.state.correctPartNumber !==
            this.props.claimPartDetails.partNumber.corrected ||
            this.state.primePartDescription !==
            this.props.claimPartDetails.partDescription ) {

            const updatedData = {
                correctedPartNumber: this.state.correctPartNumber,
                primePartDescription: this.state.primePartDescription,
            };

            this.props.updateClaim( 'primePartFailure', updatedData );

            this.props.enableEditCmp( 'Prime Part Failure' );

        } else this.onCancelBtnClicked();

    }

    onCancelBtnClicked = () => {

        if ( this.props.enableEditCmp( 'Prime Part Failure' ) ) {

            const { partNumber, partDescription } = this.props.claimPartDetails;
            this.setState( {
                correctPartNumber: getFieldValue( partNumber.corrected ),
                primePartDescription: getFieldValue( partDescription.corrected ),
            } );

        }

    }

    updatePrimePart = primePart => {

        const { name, value } = primePart.target;
        this.updateState( name, value );
        if ( primePart.target.name === 'correctPartNumber' ) {

            this.setState( {
                primePartDescription: '',
            } );

        }

    }

    updateState = ( propName, propValue ) => {

        this.setState( {
            [propName]: propValue,
        } );

    }

    render () {


        return (
            <div className="basic-claim ">
                <section className="part-information">
                    <header>
                        {( ( this.props.isComponentEdit ) || ( this.componentCodeEditable ) ) && (

                            <h4 className="page-header">
                                <i title="Edit" className={`fa fa-edit ${!this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onEditBtnClicked} />
                                <i className={`fa fa-save ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onSaveBtnClicked} />
                                <i className={`fa fa-remove ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onCancelBtnClicked} />
                            </h4>
                        )}
                    </header>
                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="originalPartNumber"
                                isEditable={false}
                                label="Original Part Number"
                                value={this.originalPartNumber}
                            />

                        </div>
                        <div className="four-cols">

                            <LabeledInput
                                className="basic-claim-info"
                                name="correctPartNumber"
                                isEditable={this.props.isEdit}
                                label="Corrected Part Number"
                                value={this.state.correctPartNumber}
                                onChange={this.updatePrimePart.bind( this )}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledTextarea
                                className="basic-claim-info"
                                name="primePartDescription"
                                isEditable={this.props.isEdit}
                                onChange={this.updatePrimePart.bind( this )}
                                value={this.state.primePartDescription}
                                label="Prime Part Description"
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="partArea"
                                isEditable={false}
                                label="Part Area"
                                value={this.partArea}
                            />
                        </div>

                    </div>
                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="totalCost"
                                isEditable={false}
                                label="Total Cost"
                                value={`$${this.totalCost}`}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="partAmount"
                                isEditable={false}
                                label="Part Cost"
                                value={`$${this.partAmount}`}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="laborHours"
                                isEditable={false}
                                label="Labor Hours"
                                value={this.laborHours}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="laborAmountUsd"
                                isEditable={false}
                                label="Labor Cost"
                                value={`$${this.laborAmountUsd}`}
                            />
                        </div>
                    </div>

                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="otherCreditsNetAmount"
                                isEditable={false}
                                label="Other Costs"
                                value={`$${this.otherCreditsNetAmount}`}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="dealerParticipationAmount"
                                isEditable={false}
                                label="Dealer Participation"
                                value={`$${this.dealerParticipationAmount}`}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="companyParticipationAmount"
                                isEditable={false}
                                label="Company Participation"
                                value={`$${this.companyParticipationAmount}`}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="customerParticipationAmount"
                                isEditable={false}
                                label="Customer Participation"
                                value={`$${this.customerParticipationAmount}`}
                            />
                        </div>
                    </div>

                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="factoryAmount"
                                isEditable={false}
                                label="Factory Total"
                                value={`$${this.factoryAmount}`}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="nonMetric"
                                isEditable={false}
                                label="Non Metric Code"
                                value={this.nonMetric}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="failureMode"
                                isEditable={false}
                                label="Failure Mode Code"
                                value={this.failureMode}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="downtime"
                                isEditable={false}
                                label="Downtime Indicator"
                                value={this.downtime}
                            />
                        </div>
                    </div>

                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="componentNonMetric"
                                isEditable={false}
                                label="Component Non-Metric Flag"
                                value={this.componentNonMetric}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="multipleSuppliers"
                                isEditable={false}
                                label="Multiple Supplier Indicator"
                                value={this.multipleSuppliers}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="multipleFail"
                                isEditable={false}
                                label="Multiple Fail Code"
                                value={this.multipleFail}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="failedTrackSerialNumber"
                                isEditable={false}
                                label="Failed Track Serial Number"
                                value={this.failedTrackSerialNumber}
                            />
                        </div>
                        

                    </div>

                </section>


            </div>
        );

    }

}
PrimePartInfo.displayName = 'PrimePartInfo';
PrimePartInfo.propTypes = {
    claimPartDetails: PropTypes.object.isRequired,
    updateClaim: PropTypes.func.isRequired,
    isComponentEdit: PropTypes.bool.isRequired,
    enableEditCmp: PropTypes.func,
    isEdit: PropTypes.bool.isRequired,
};
export default PrimePartInfo;
